import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '..';

const getEvents = createSelector(
  (state: RootState) => state.events,
  events => events,
);

const getFutureEvents = createSelector(
  (state: RootState) => state.events,
  events => events.futureEvents,
);

const getPastEvents = createSelector(
  (state: RootState) => state.events,
  events => events.pastEvents,
);

const getEventsLoadedStatus = createSelector(
  (state: RootState) => state.events,
  events => ({
    hasLoadedFutureEvents: events.hasLoadedFutureEvents,
    hasLoadedPastEvents: events.hasLoadedPastEvents,
    loading: events.loading,
    loadingPast: events.loadingPast,
  }),
);

const getDrafts = createSelector(
  (state: RootState) => state.events,
  events => events.drafts,
);

const getDraftsLoadingStatus = createSelector(
  (state: RootState) => state.events,
  events => ({
    hasLoadedDrafts: events.hasLoadedDrafts,
    loadingDrafts: events.loadingDrafts,
  }),
);

const getDraftById = (draftId: string) =>
  createSelector(
    (state: RootState) => state.events.drafts,
    drafts => drafts.find(draft => draft.id === draftId),
  );

export const EventSelector = {
  getEvents,
  getFutureEvents,
  getPastEvents,
  getEventsLoadedStatus,
  getDrafts,
  getDraftsLoadingStatus,
  getDraftById,
};
